import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import StudentRoute from './components/StudentRoute';
import AutoRedirect from './components/AutoRedirect';
import Login from './components/Login';
import Register from './components/Register';
import Sidebar from './components/Sidebar';
import Dashboard from './components/Dashboard';
import Escolas from './components/Escolas';
import UsuariosAdministrativos from './components/UsuariosAdministrativos';
import Materias from './components/Materias';
import Conteudos from './components/Conteudos';
import AnosEscolares from './components/AnosEscolares';
import TermosUso from './components/TermosUso';
import ContextosIa from './components/ContextosIa';
import Configuracoes from './components/Configuracoes';
import Usuarios from './components/Usuarios';
import FuncoesUsuarios from './components/FuncoesUsuarios';
import Alunos from './components/Alunos';
import Testes from './components/Testes';
import Respostas from './components/Respostas';
import Relatorios from './components/Relatorios';
import Conversas from './components/Conversas';
import AlunoInterface from './components/AlunoInterface';
import './App.css';

// Componente para o layout do dashboard - APENAS para ADMIN
const DashboardLayout = ({ children }) => {
  const { user } = useAuth();
  
  // Se não é admin, não renderizar o layout
  if (!user || user.userType !== 'admin') {
    return null;
  }
  
  return (
    <div className="app">
      <Sidebar />
      <main className="main-content">
        {children}
      </main>
    </div>
  );
};

// Componente principal da aplicação (dentro do AuthProvider)
const AppContent = () => {
  return (
    <Router>
      <AutoRedirect />
      <Routes>
        {/* Rotas públicas */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        
        {/* Rotas protegidas - APENAS para ADMIN */}
        <Route path="/" element={
          <AdminRoute>
            <DashboardLayout>
              <Dashboard />
            </DashboardLayout>
          </AdminRoute>
        } />
        
        <Route path="/escolas" element={
          <AdminRoute>
            <DashboardLayout>
              <Escolas />
            </DashboardLayout>
          </AdminRoute>
        } />
        
        <Route path="/usuarios-administrativos" element={
          <AdminRoute>
            <DashboardLayout>
              <UsuariosAdministrativos />
            </DashboardLayout>
          </AdminRoute>
        } />
        
        <Route path="/materias" element={
          <AdminRoute>
            <DashboardLayout>
              <Materias />
            </DashboardLayout>
          </AdminRoute>
        } />
        
        <Route path="/conteudos" element={
          <AdminRoute>
            <DashboardLayout>
              <Conteudos />
            </DashboardLayout>
          </AdminRoute>
        } />
        
        <Route path="/anos-escolares" element={
          <AdminRoute>
            <DashboardLayout>
              <AnosEscolares />
            </DashboardLayout>
          </AdminRoute>
        } />
        
        <Route path="/contextos-ia" element={
          <AdminRoute>
            <DashboardLayout>
              <ContextosIa />
            </DashboardLayout>
          </AdminRoute>
        } />
        
        <Route path="/termos-uso" element={
          <AdminRoute>
            <DashboardLayout>
              <TermosUso />
            </DashboardLayout>
          </AdminRoute>
        } />
        
        <Route path="/configuracoes" element={
          <AdminRoute>
            <DashboardLayout>
              <Configuracoes />
            </DashboardLayout>
          </AdminRoute>
        } />
        
        <Route path="/usuarios" element={
          <AdminRoute>
            <DashboardLayout>
              <Usuarios />
            </DashboardLayout>
          </AdminRoute>
        } />
        
        <Route path="/funcoes-usuarios" element={
          <AdminRoute>
            <DashboardLayout>
              <FuncoesUsuarios />
            </DashboardLayout>
          </AdminRoute>
        } />
        
        <Route path="/alunos" element={
          <AdminRoute>
            <DashboardLayout>
              <Alunos />
            </DashboardLayout>
          </AdminRoute>
        } />
        
        <Route path="/testes" element={
          <AdminRoute>
            <DashboardLayout>
              <Testes />
            </DashboardLayout>
          </AdminRoute>
        } />
        
        <Route path="/respostas" element={
          <AdminRoute>
            <DashboardLayout>
              <Respostas />
            </DashboardLayout>
          </AdminRoute>
        } />
        
        <Route path="/relatorios" element={
          <AdminRoute>
            <DashboardLayout>
              <Relatorios />
            </DashboardLayout>
          </AdminRoute>
        } />
        
        <Route path="/conversas" element={
          <AdminRoute>
            <DashboardLayout>
              <Conversas />
            </DashboardLayout>
          </AdminRoute>
        } />
        
        {/* Rota para interface do aluno - APENAS para STUDENT */}
        <Route path="/aluno" element={
          <StudentRoute>
            <AlunoInterface />
          </StudentRoute>
        } />
        
        {/* Rota catch-all - redireciona para home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
